import classNames from 'clsx';
import React from 'react';
import type { ReactElement } from 'react';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';

import NoDataIcon from '../../assets/no-data.svg';
import NoPokerNoDataIcon from '../../assets/no-poker-no-data.svg';
import { handleShowingBrandIconElement } from '../../utils/isPokerSiteLabel';

import styles from './NoData.scss';

interface Props {
  className?: string;
  icon?: ReactElement;
  primaryText: React.ReactNode;
  secondaryText: React.ReactNode;
}

const NoData: React.FC<React.PropsWithChildren<Props>> = ({
  icon,
  primaryText,
  secondaryText,
  className,
  children
}) => {
  const isExternalPartnerSite = useSelector(select.cms.isExternalPartnerSite);
  const iconImg = icon
    ? icon
    : handleShowingBrandIconElement(isExternalPartnerSite, <NoPokerNoDataIcon />, <NoDataIcon />);

  return (
    <div className={classNames(styles.container, className)} data-testid="no-data">
      <div className={styles.icon}>{iconImg}</div>
      <div className={styles.primaryText}>{primaryText}</div>
      <div className={styles.secondaryText}>{secondaryText}</div>
      {children}
    </div>
  );
};

export default NoData;
